const PreferenceTypeEnum = Object.freeze({
    NOTIFICATIONS: 'NOTIFICATIONS'
});

export default PreferenceTypeEnum;
